module.exports = __webpack_public_path__ + "img/dashboard.deb3fca6.svg";